import $ from 'jquery';
import Checkbox from './components/Checkbox';
import Products from './components/Products';
import Radio from './components/Radio';
import Modal from './components/Modal';
import Submenu from './components/Submenu';
import Events from './components/Events';
import Orders from './components/Orders';
import Account from './components/Account';
import Navigation from './components/Navigation';
import Basket from './components/Basket';
import Search from "./components/Search";
import MostOrdered from "./components/MostOrdered";

require('jquery-match-height/jquery.matchHeight.js');

window.delay = function (callback, ms) {
    var timer = 0;
    return function() {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
};

// Select2 fix code to prevent jumpy behavior on open dropdown
(function ($) {
    $('body').on('keyup', '.product-item__add-to-basket-quantity', delay(Products.updatePriceQty, 250));
    $('body').on('click, change', '.single-box-measure-unit', delay(Products.updatePriceQty, 0));

    var Defaults = $.fn.select2.amd.require('select2/defaults');

    $.extend(Defaults.defaults, {
        dropdownPosition: 'auto'
    });

    var AttachBody = $.fn.select2.amd.require('select2/dropdown/attachBody');

    var _positionDropdown = AttachBody.prototype._positionDropdown;

    AttachBody.prototype._positionDropdown = function () {

        var $window = $(window);

        var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
        var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');

        var newDirection = null;

        var offset = this.$container.offset();

        offset.bottom = offset.top + this.$container.outerHeight(false);

        var container = {
            height: this.$container.outerHeight(false)
        };

        container.top = offset.top;
        container.bottom = offset.top + container.height;

        var dropdown = {
            height: this.$dropdown.outerHeight(false)
        };

        var viewport = {
            top: $window.scrollTop(),
            bottom: $window.scrollTop() + $window.height()
        };

        var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
        var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);

        var css = {
            left: offset.left,
            top: container.bottom
        };

        // Determine what the parent element is to use for calciulating the offset
        var $offsetParent = this.$dropdownParent;

        // For statically positoned elements, we need to get the element
        // that is determining the offset
        if ($offsetParent.css('position') === 'static') {
            $offsetParent = $offsetParent.offsetParent();
        }

        var parentOffset = $offsetParent.offset();

        css.top -= parentOffset.top
        css.left -= parentOffset.left;

        var dropdownPositionOption = this.options.get('dropdownPosition');

        if (dropdownPositionOption === 'above' || dropdownPositionOption === 'below') {
            newDirection = dropdownPositionOption;
        } else {

            if (!isCurrentlyAbove && !isCurrentlyBelow) {
                newDirection = 'below';
            }

            if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
                newDirection = 'above';
            } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
                newDirection = 'below';
            }

        }

        if (newDirection == 'above' ||
            (isCurrentlyAbove && newDirection !== 'below')) {
            css.top = container.top - parentOffset.top - dropdown.height;
        }

        if (newDirection != null) {
            this.$dropdown
                .removeClass('select2-dropdown--below select2-dropdown--above')
                .addClass('select2-dropdown--' + newDirection);
            this.$container
                .removeClass('select2-container--below select2-container--above')
                .addClass('select2-container--' + newDirection);
        }

        this.$dropdownContainer.css(css);

    };

})(window.jQuery);

var saveLastGoodUrlAndOffsetHandler = function() {
    $(window).on('unload', function () {
        if (window.location.pathname === '/' || window.location.pathname.includes('/products') ||
            window.location.pathname.includes('/product/') || window.location.pathname.includes('/news/show/') ||
            window.location.pathname.includes('/promotion/')) {

            localStorage.setItem('lastGoodUrl', window.location.href);

            if (!window.location.href.includes('/product/')) {
                localStorage.setItem('lastGoodOffset', $(window).scrollTop().toString());
            }
        }
    })
}

$(document).ready(function () {

    Checkbox.init();
    Radio.init();
    Submenu.init();
    Orders.init();
    Account.init();
    Navigation.init();
    Products.productsEqualTitlesHandler();
    Products.initDiscountsLoading();
    Products.initProductPartOfPromopackBadgeLoading();
    Products.initProductPartOfMultilineBadgeLoading();
    Products.getProductRelatedPromopacks();
    Basket.init();
    Search.init();
    MostOrdered.init();
    saveLastGoodUrlAndOffsetHandler();

    if ($('.products').length > 0) {
        Products.init();
        Modal.initCompareModal();
        Modal.removeProductFromCompareModalListener();
    }

    if ($('.featured-products').length > 0) {
        Modal.initCompareModal();
        Modal.removeProductFromCompareModalListener();
    }

    if ($('.events').length > 0) {
        Events.init();
    }

    if ($('.products-details').length > 0) {
        Products.initDetails();
        Products.productDetailsRelatedInfoNavigationHandler();
        Products.productDetailsGalleryHandler();
    }

    if ($('.decimal').length >  0) {
        Products.validateProductQuantityInput();
    }

    if ($('.products-series-details').length > 0) {
        Products.seriesProductsDataExpandHandler();
    }

    if ($('.banners__carousel-items-info').length > 0) {
        if ($(window).width() > 991) {
            $('.banners__carousel-items-info').matchHeight();
        }
    }

    if ($('.equipment__products-item-inner').length > 0) {
        if ($(window).width() > 991) {
            $('.equipment__products-item-inner').matchHeight();
        }
    }

    // Scroll to position if it has key in localstorage hasToScroll
    if (window.location.pathname === '/' || window.location.pathname.includes('/products') ||
        window.location.pathname.includes('/product/') || window.location.pathname.includes('/news/show/') ||
        window.location.pathname.includes('/promotion/')) {

        if (window.location.pathname.includes('/product/') &&
            window.location.href !== localStorage.getItem('lastGoodUrl') &&
            localStorage.getItem('lastGoodUrl') !== null) {
            $('.products-details').find('.btn--back-to-url').removeClass('d-none');
        }

        if (localStorage.getItem('hasToScroll') !== null && parseInt(localStorage.getItem('hasToScroll')) == 1) {
            var top = parseFloat(localStorage.getItem('lastGoodOffset'));
            $("html, body").stop().animate({scrollTop: top}, 500, 'swing', function() {
                localStorage.removeItem('hasToScroll');
            });
        }
    }

    $(window).resize(function() {
        if ($('.banners__carousel-items-info').length > 0) {
            if ($(window).width() > 991) {
                $('.banners__carousel-items-info').matchHeight();
            }
        }

        if ($('.equipment__products-item-inner').length > 0) {
            if ($(window).width() > 991) {
                $('.equipment__products-item-inner').matchHeight();
            }
        }
    })


    Products.mobileCompareMove();
});
